import { render, staticRenderFns } from "./Phases.vue?vue&type=template&id=286f3e78&scoped=true"
import script from "./Phases.vue?vue&type=script&lang=js"
export * from "./Phases.vue?vue&type=script&lang=js"
import style0 from "./Phases.vue?vue&type=style&index=0&id=286f3e78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286f3e78",
  null
  
)

export default component.exports